<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title
        v-show="showTitleContent"
        class="card-title"
      >
        <v-layout wrap>
          <v-flex :xs10="closeButton">
            <slot name="title" />
          </v-flex>
          <v-flex
            v-if="closeButton"
            xs2
          >
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text
        v-show="showFixedContent"
        class="card-title"
      >
        <slot name="fixed" />
      </v-card-text>
      <div :class="{ 'container-scroll-y': isFixedTop }">
        <v-card-text>
          <slot name="content" />
        </v-card-text>
        <v-card-actions>
          <slot name="actions" />
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'AppModal',
    props: {
        maxWidth: {
            type: Number,
            default: 750
        },
        persistent: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            required: true
        },
        closeButton: {
            type: Boolean,
            default: true
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        isFixedTop: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dialog: false
        };
    },
    computed: {
        showTitleContent () {
            if (this.showTitle === false) {
                return false;
            }
            return this.$slots.title != null || this.closeButton === true;
        },
        showFixedContent () {
            return this.$slots.fixed != null;
        }
    },
    watch: {
        visible: {
            handler (val) {
                this.dialog = val;
            }
        },
        dialog () {
            if (!this.dialog) {
                this.$emit('close', false);
            }
        }
    },
    methods: {
        closeDialog () {
            this.dialog = false;
            this.$emit('closeButton');
            this.$emit('close', false);
        }
    }
};
</script>

<style scoped>
.container-scroll-y {
  position: relative;
  overflow-y: scroll;
  max-height: 460px;
}
</style>
